import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import { Link, useHistory, Redirect } from "react-router-dom";
import { isEmpty, size } from "lodash";
import { showToast } from '../../UI/ui-toast';
import { get_user_permissions } from "../../../helpers/custom_helper"

import DeleteModal from "../../../components/Common/DeleteModal";
import moment from "moment";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { get_all_project_reports } from '../api/reportsApi';

import default_avatar from "../../../assets/images/avatar_01.png";
var agentEdit, agentView, agentCreate, agentDelete;

class ListProjectReports extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            page: 1,
            sizePerPage: 10,
            listData: [],
            listdata: "",
            viewmodal: false,
            modal: false,
            isOpen: false,
            selectDate: false,
            deleteModal: false,
            recordDeleteID: null,
            redirect: null
        };
        this.handleRecordClick = this.handleRecordClick.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleRecordClicks = this.handleRecordClicks.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.handleListAvailableProperties = this.handleListAvailableProperties.bind(this);
        this.handleListSoldProperties = this.handleListSoldProperties.bind(this);
        this.handleListTotalProperties = this.handleListTotalProperties.bind(this);
    }
    componentDidMount() {
        window.localStorage.removeItem('current_project_id_for_available')
        window.localStorage.removeItem('current_project_id_for_sold')
        Promise.all([get_all_project_reports()]).then((values) => {
            this.setState({ listData: values[0] });
            console.log(values[0]);
        });

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listData } = this.props;
        if (!isEmpty(listData) && size(prevProps.listData) !== size(listData)) {
            this.setState({ listData: {}, isEdit: false });
        }
    }
    onPaginationPageChange = page => {
        if (
            this.node &&
            this.node.current &&
            this.node.current.props &&
            this.node.current.props.pagination &&
            this.node.current.props.pagination.options
        ) {
            this.node.current.props.pagination.options.onPageChange(page);
        }
    };
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ deleteModal: true });
    };

    handleDeletejob = () => {
        // const { onDeleteJobList } = this.props;
        const { listdata } = this.state;
        if (listdata.id !== undefined) {
            console.log(this.state.recordDeleteID);
            // onDeleteJobList(listdata);
            /*Promise.all([delete_project(this.state.recordDeleteID)]).then((values) => {
                Promise.all([get_all_customers()]).then((values) => {
                    console.log(values[0]);
                    this.setState({ listData: values[0] });
                });
            });*/

            // Promise.all([delete_salesagents(this.state.recordDeleteID)]).then((values) => {
            //     showToast("Sales Agent", "The sales agent has been deleted successfully.", "success");
            //     Promise.all([get_all_saleagents()]).then((values) => {
            //         this.setState({ listData: values[0] });
            //     });
            // }).catch((error) => {
            //     showToast("Sales Agent", "Sales Agent Not Deleted", "error");
            // });

            // this.setState({ deleteModal: false });
        }
    };

    handleRecordClicks = () => {
        this.setState({ listdata: "", isEdit: false });
        this.toggle();
    };
    handleListAvailableProperties = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_project_id_for_available", listdata.project_id);
        this.setState({ redirect: "/project-report/properties/available/list" });
    };
    handleListSoldProperties = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_project_id_for_sold", listdata.project_id);
        this.setState({ redirect: "/project-report/properties/sold/list" });
    };
    handleListTotalProperties = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_project_id_for_total", listdata.project_id);
        this.setState({ redirect: "/project-report/properties/total/list" });
    };

    handleRecordClick = arg => {
        const listdata = arg;

        /*this.setState({
            listdata: {
                id: listdata.id,
                name: listdata.name,
            },
            isEdit: true,
        });

        this.toggle();*/
        window.localStorage.setItem("current_salesagent", listdata.id);
        this.setState({ redirect: "/salesagents/edit" });
    };
    render() {

        const { isEdit, deleteModal } = this.state;

        const listdata = this.state.listdata;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        const columns = [
            {
                dataField: "project_name",
                text: "Project Name",
                sort: true,
            },
            {
                dataField: "country",
                text: "Country",
                sort: false,
            },
            {
                dataField: "city",
                text: "City",
                sort: false,
            },
            // {
            //     dataField: "total_properties",
            //     text: "Total Properties",
            //     sort: false,
            //     formatter: (cellContent, listdata) => (
            //         <>
            //             <ul className="list-unstyled text-center mb-0">
            //                 <li>
            //                    {listdata.total_properties}
            //                 </li>
            //             </ul>
            //         </>
            //     ),
            // },
            // {
            //     dataField: "sold_properties",
            //     text: "Sold Properties",
            //     sort: false,
            // },
            // {
            //     dataField: "available_properties",
            //     text: "Available Properties",
            //     sort: false,
            // },
            {
                dataField: "action",
                isDummyField: true,
                text: "Total Properties",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled text-center mb-0">
                            <li>
                                {listdata.total_properties==0?listdata.total_properties:<>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => this.handleListTotalProperties(listdata)}
                                >
                                    {listdata.total_properties}
                                </Link>
                                </>}
                            </li>
                        </ul>
                    </>
                ),
            },
            {
                dataField: "action",
                isDummyField: true,
                text: "Sold Properties",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled text-center mb-0">
                            <li>
                                {listdata.sold_properties==0?listdata.sold_properties:<>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => this.handleListSoldProperties(listdata)}
                                >
                                    {listdata.sold_properties}
                                </Link>
                                </>}
                            </li>
                        </ul>
                    </>
                ),
            },
            {
                dataField: "action",
                isDummyField: true,
                text: "Available Properties",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled text-center mb-0">
                            <li>
                                {listdata.available_properties==0?listdata.available_properties:<>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => this.handleListAvailableProperties(listdata)}
                                >
                                    {listdata.available_properties}
                                </Link>
                                </>}
                            </li>
                        </ul>
                    </>
                ),
            },
        ];

        const defaultSorted = [
            {
                dataField: "project_id",
                order: "asc",
            },
        ];

        const pageOptions = {
            sizePerPage: 10,
            // totalSize: productsData.length, // replace later with size(customers),
            custom: true,
        };

        // Select All Button operation
        const selectRow = {
            mode: "checkbox",
        };

        const { SearchBar } = Search;

        //meta title
        document.title = "Report - All Due Payments";
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.setState({ recordDeleteID: row.id });
            }
        }
        return (
            <React.Fragment>
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeletejob}
                    record={`project report`}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="Reports" breadcrumbItem="List Project Reports" />

                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1">List Project Reports</h5>
                                                {/* {agentCreate ? <>
                                                    <div className="flex-shrink-0">
                                                        <Link to="/salesagents/add" className="btn btn-primary me-1">Add New Sales Agent</Link>
                                                    </div>
                                                </> : <></>} */}
                                            </div>
                                        </CardBody>
                                        <PaginationProvider
                                            pagination={paginationFactory(pageOptions)}
                                            keyField="id"
                                            columns={columns}
                                            data={this.state.listData}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="id"
                                                    columns={columns}
                                                    data={this.state.listData}
                                                    search
                                                >
                                                    {toolkitProps => (
                                                        <React.Fragment>
                                                            <Row className="mb-2">
                                                                <Col md="4">
                                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                                        <div className="position-relative">
                                                                            <SearchBar
                                                                                {...toolkitProps.searchProps}
                                                                            />
                                                                            <i className="bx bx-search-alt search-icon" />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <BootstrapTable
                                                                            keyField={"id"}
                                                                            responsive
                                                                            bordered={false}
                                                                            striped={false}
                                                                            defaultSorted={defaultSorted}
                                                                            selectRow={selectRow}
                                                                            rowEvents={rowEvents}
                                                                            classes={
                                                                                "table align-middle table-nowrap"
                                                                            }
                                                                            headerWrapperClasses={"thead-light"}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}
                                                                            ref={this.node}
                                                                        />
                                                                        <Modal
                                                                            isOpen={this.state.modal}
                                                                            className={this.props.className}
                                                                        >
                                                                            <ModalHeader toggle={this.toggle} tag="h4">
                                                                                {!!isEdit ? "Edit Payment Report" : "Add Payment Report"}
                                                                            </ModalHeader>
                                                                            <ModalBody>
                                                                                <Formik
                                                                                    enableReinitialize={true}
                                                                                    initialValues={{
                                                                                        id: (listdata && listdata.id) || '',
                                                                                        name: (listdata && listdata.name) || '',
                                                                                    }}
                                                                                    validationSchema={Yup.object().shape({
                                                                                        id: Yup.string().required("Please Enter Your Id"),
                                                                                        name: Yup.string().required("Please Enter Your Name"),
                                                                                    })}
                                                                                    onSubmit={values => {
                                                                                        /*Promise.all([update_project(values.id, values.name)]).then((response) => {
                                                                                            console.log(response[0]);
                                                                                            Promise.all([get_all_saleagents()]).then((values) => {
                                                                                                console.log(values[0]);
                                                                                                this.setState({ listData: values[0] });
                                                                                            });
                                                                                        });*/
                                                                                        this.toggle();
                                                                                    }}
                                                                                >
                                                                                    {({ errors, status, touched }) => (
                                                                                        <Form>
                                                                                            <Row>
                                                                                                <Col className="col-12">
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                        Payment Report Id
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="id"
                                                                                                            disabled
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.id &&
                                                                                                                    touched.id
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="id"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Name
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="name"
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.name &&
                                                                                                                    touched.name
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="name"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <div className="text-end">
                                                                                                        <button
                                                                                                            type="submit"
                                                                                                            className="btn btn-primary save-user"
                                                                                                        >
                                                                                                            Save
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Form>
                                                                                    )}
                                                                                </Formik>
                                                                            </ModalBody>
                                                                        </Modal>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="align-items-md-center mt-30">
                                                                <Col className="inner-custom-pagination d-flex">
                                                                <div className="d-inline">Results Per Page&nbsp;&nbsp;
                                                                        <SizePerPageDropdownStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                    <div className="text-md-right ms-auto">
                                                                        <PaginationListStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default ListProjectReports;
